import cheader from '@/components/header/index.vue'

export default {
	name: 'ordeResult',
	data() {
		return {
			serverUrl: this.$store.state.config.serverUrl,
			isTicket: '',
			nowData:[],
			shows:"",
			totalPrice:0,
			economizeMoney:0,
			manyMoney:0,
			goodInfoVisable:false,
			pageNum:1,
			pageSize:10,
			infoData:[],
			orders: [],
			titles:"",
			loadingdc:false,
			loading:true,
			loading1:true,
			pageTotal:0,
			isDak:false
		}
	},
	computed: {
		user() {
			return this.$store.state.user
		},
		// shows: {
		// 	get() {
		// 		console.log(this.orders)
		// 		return this.orders.map((item) => {
		// 			return item.supplier.user.id
		// 		})
		// 	},
		// 	set() {
		// 	}
		// },
		description() {
			let desc = '总共 ' + this.orders.length + ' 项，总价' + this.totalPrice + '元'
			if(this.economizeMoney!=0){
				desc+='，节省' + this.economizeMoney + '元'
			}
		    if(this.manyMoney>0){
				desc+='，多花' + this.manyMoney + '元'
			}
			return desc
		},
		total() {
			let oobj = {};
			let total = 0
			let reduce = 0;
			for (let order of this.orders) {
				for (let good of order.productList) {
					total += good.available * (this.isTicket == 'true' ? good.ticket : good.unticket)
					if (good.enquiryTicket) {
						if (this.isTicket == 'true' && parseFloat(good.enquiryTicket) > parseFloat(good.ticket)) {
							good.reduce = (parseFloat(good.enquiryTicket) - parseFloat(good.ticket)).toFixed(2)
							reduce += good.available * good.reduce
						}

						if (this.isTicket != 'true' && parseFloat(good.enquiryTicket) > parseFloat(good.unticket)) {
							good.reduce = (parseFloat(good.enquiryTicket) - parseFloat(good.unticket)).toFixed(2)
							reduce += good.available * good.reduce
						}
					}
				}
			}
			oobj.total = total.toFixed(2)
			oobj.reduce = reduce.toFixed(2)
			return oobj
		}
	},
	components: {
		cheader
	},
	created() {
		this.show()
	},
	methods: {
		getSummaries (param) {
			const { columns, data } = param;
			console.log("111111",data)
			const sums = [];
			columns.forEach((column, index) => {
			  if (index === 0) {
				sums[index] = '总价';
				return;
			  }
			  const values = data.map(item => Number(item[column.property]));
			  if (!values.every(value => isNaN(value)) && index == 3 || index == 4 || index == 5 || index == 6 || index == 7) {
				sums[index] = values.reduce((prev, curr) => {
				  const value = Number(curr);
				  if (!isNaN(value)) {
					return prev + value;
				  } else {
					return prev;
				  }
				}, 0);
				if(index == 6 || index == 7 || index == 3){
					sums[index] = sums[index].toFixed(2)
				}else if(index == 4){
					sums[index] = sums[index].toFixed(4)
				}else{
					sums[index];
				}
			  } else {
				sums[index] = '';
			  }
			});
			return sums;
	  
		},
		go(url) {
			this.$router.push(url)
		},
		handleSizeChange(val) {
            this.pageSize = val;
			var type = ""
			if(this.titles == "多花"){
				type = "up"
			}else{
				type = "low"
			}
            this.findInfoData(type)
        },
		// 分页导航
        handlePageChange(val) {
            this.pageNum = val
			var type = ""
			if(this.titles == "多花"){
				type = "up"
			}else{
				type = "low"
			}
            this.findInfoData(type);
        },
		findInfoData(type){
			this.goodInfoVisable=true
			if(type=='up'){
				this.titles = "多花"
			}else{
				this.titles = "节省"
			}
			var params = {
				enquiryId:this.$route.params.id,
				userId:this.user.id,
				balanceType:type,
				pageNo:this.pageNum,
				pageSize:this.pageSize
			}
			this.$http.get('/api/inquiry/balance', { params:params }).then((res) => {
				this.loading = false
				this.infoData = res.data.data
				this.pageTotal = res.data.total
			})
		},
		handleChange(supplierId){
			this.loading1 = true
			this.$http.get('/api/inquiry/getEnquiryProduct', { params: { id: this.$route.params.id,supplierId:supplierId,userId:this.user.id } }).then((res) => {
				this.nowData = res.data.data
				this.loading1=false
			})
		},
		show() {
			this.$http.get('/api/inquiry/getEnquiry', { params: { id: this.$route.params.id,userId:this.user.id } }).then((res) => {
				this.isTicket = res.data.data.inquiryPrice.isTicket
				this.orders = res.data.data.supplierProductList
				this.totalPrice = res.data.data.totalPrice
				this.economizeMoney = res.data.data.economizeMoney
				this.manyMoney = res.data.data.manyMoney
				this.isDak = res.data.data.isDak
			})
		},
		importer() {
			this.loadingdc=true
			this.$http.get('/api/inquiry/exportEnquiry', { params: { id: this.$route.params.id,userId:this.user.id } }).then((res) => {
				// console.log(this.serverUrl)
				// console.log(res)
				this.loadingdc = false
				window.location.href = this.serverUrl + res.data.data
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/home/order/result/index.js